import { Grid } from '@mui/material';
import AryModal from 'framework/base/components/AryModal';
import { GET_STATE } from 'framework/base/constants/aryGraphqlSchemas';
import { SUBMIT_TRANSFER_BETWEEN_ACCOUNTS_TRANSACTION } from 'framework/base/constants/aryRestCommands';
import useAryDelayedRestData from 'framework/base/hooks/useAryDelayedRestData';
import { getMoonUtcTime } from 'framework/base/utils/Utils';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TransferBetweenAccountsBase from './TransferBetweenAccountsBase';

const SubmitTransferBetweenAccountsModal = ({
  handleChangeAccountNumber,
  onReceiptModalClose,
  open,
  handleClose
}) => {
  const transferBetweenAccountsBaseRef = useRef(null);
  const [submittedTransactionId, setSubmittedTransactionId] = useState('');
  const { t } = useTranslation();

  const [
    submitTransferBetweenAccountsTransaction,
    { loading: submitTransferBetweenAccountsLoading }
  ] = useAryDelayedRestData({
    api: SUBMIT_TRANSFER_BETWEEN_ACCOUNTS_TRANSACTION,
    type: GET_STATE.type.ACCOUNTING,
    onSucceed: ({ transactionId: transferBetweenAccountsTransactionId }) => {
      setSubmittedTransactionId(transferBetweenAccountsTransactionId);
      transferBetweenAccountsBaseRef.current.handleOpenReceiptModal();
    }
  });

  return (
    <AryModal
      open={open}
      handleClose={handleClose}
      noCloseOnOutsideClicked
      width="52rem"
      title={t('transfer between accounts')}
    >
      <Grid item xs={12}>
        <TransferBetweenAccountsBase
          ref={transferBetweenAccountsBaseRef}
          onSubmit={(values) => {
            const {
              hasDebtorCommission,
              hasCreditorCommission,
              ...transactionItem
            } = { ...values };

            transactionItem.date = getMoonUtcTime(transactionItem.date);

            if (values.hasDebtorCommission) {
              transactionItem.debtorCommissionAmount =
                transactionItem.debtorCommissionAmount || undefined;
            } else {
              transactionItem.debtorCommissionCurrencyCode = '';
              transactionItem.debtorCommissionAmount = undefined;
            }
            if (values.hasCreditorCommission) {
              transactionItem.creditorCommissionAmount =
                transactionItem.creditorCommissionAmount || undefined;
            } else {
              transactionItem.creditorCommissionCurrencyCode = '';
              transactionItem.creditorCommissionAmount = undefined;
            }

            submitTransferBetweenAccountsTransaction(transactionItem);
          }}
          submitButtonLoading={submitTransferBetweenAccountsLoading}
          submitButtonLabel={t('SubmitTransfer')}
          onReceiptModalClose={onReceiptModalClose}
          handleCloseParentModal={handleClose}
          handleChangeAccountNumber={handleChangeAccountNumber}
          transactionId={submittedTransactionId}
        />
      </Grid>
    </AryModal>
  );
};

export default SubmitTransferBetweenAccountsModal;
